import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { PrioritiesInventoryRequest, PrioritiesInventoryResponse, ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { ProductFavoriteService } from 'src/app/services/product-favorite.service';
import { ProductService } from 'src/app/services/product.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-modal-priority-inventory',
  templateUrl: './modal-priority-inventory.component.html',
  styleUrls: ['./modal-priority-inventory.component.scss']
})
export class ModalPriorityInventoryComponent implements OnInit {
  @Output() close = new EventEmitter<any>();
  warehouses: WarehouseResponse[] = [];
  products: ProductResponse[] = [];
  warehouse = new InputAutocompleteModel("", false, true, "", "loading", "", "", null, []);
  product = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  timeout = null;
  priorities: PrioritiesInventoryResponse[] = [];
  alreadyPriorities: { [key: number]: boolean } = {};
  original = 0;
  buttonSave = new ButtonLoading("btn-success", false, "", "fa-save");

  constructor(
    private toastService: ToastrService,
    private warehouseService: WarehouseService,
    private inventoryService: InventoryService,
    private productService: ProductService,
    private productFavoriteService: ProductFavoriteService,
  ) {

  }

  ngOnInit(): void {
    this.getWarehouses();
    // this.getProducts();
  }

  hasProductsAdded() {
    return this.original < Object.keys(this.alreadyPriorities).length;
  }

  getWarehouses() {
    this.warehouseService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.warehouse.filterElements = this.warehouses;
        this.warehouse.class = "fa-list";
      },
      error: (error) => {
        console.log(error);
      }
    })
  }

  savePriorities() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    var request = new PrioritiesInventoryRequest();
    request.warehouse = this.warehouse.data.id;
    request.products = [];
    this.priorities.forEach((p) => {
      if (!p.id) {
        request.products.push(p.product.id);
      }
    });
    this.inventoryService.savePriorityInventory(request).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Guardados las nuevas prioridades");
        this.buttonSave.loading = false;
        this.getPrioritiesInventoryByWarehouse();
      }, 
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.toastService.error("Error al guardar las nuevas prioridades");
      }
    })
  }

  getProducts(warehouseId: number) {
    this.product.class = "loading";
    this.product.filterElements = [];

    this.productFavoriteService.getProductsByWarehouse(warehouseId).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data || [];

        this.updateProducts();

        if (this.products.length === 0) {
          this.product.class = "fa-xmark";
        } else {
          this.product.class = "fa-list";
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);

        this.products = [];
        this.product.filterElements = [];
        this.product.class = "fa-xmark";

        this.toastService.error(
          "Error al obtener los productos favoritos de la bodega"
        );
      }
    });
  }

  writeWarehouse() {
    this.warehouse.class = "typing";
    this.warehouse.filterElements = this.warehouses.filter((w) => {
      return w.name.toLowerCase().includes(this.warehouse.value.toLowerCase());
    });
    clearTimeout(this.timeout);
    if (this.warehouse.filterElements.length == 0) {
      this.warehouse.class = "fa-xmark";
      this.warehouse.verified = false;
      this.warehouse.data = null;
    } else {
      this.warehouse.class = "fa-list";
      this.warehouse.verified = false;
      this.warehouse.data = null;
    }
  }

  writeProduct() {
    if (!this.warehouse.data) {
      this.product.filterElements = [];
      this.product.class = "fa-xmark";
      return;
    }
    this.product.class = "typing";
    this.product.filterElements = this.products.filter((p: ProductResponse) => {
      var val = this.product.value.toLowerCase();
      if (this.alreadyPriorities[p.id]) {
        return false;
      }
      return p.name.toLowerCase().includes(val) || p.code?.toLowerCase().includes(val) || p.barCode?.toLowerCase().includes(val);
    });
    clearTimeout(this.timeout);
    if (this.product.filterElements.length == 0) {
      this.product.class = "fa-xmark";
    } else {
      this.product.class = "fa-list";
    }
  }

  selectWarehouse(warehouse: WarehouseResponse) {
    clearTimeout(this.timeout);
    this.warehouse.value = warehouse.name;
    this.warehouse.class = "fa-circle-check";
    this.warehouse.verified = true;
    this.warehouse.data = warehouse;
    this.products = [];
    this.priorities = [];
    this.alreadyPriorities = {};
    this.original = 0;
    this.product.value = "";
    this.product.data = null;
    this.product.filterElements = [];
    this.product.class = "loading";
    this.getProducts(warehouse.id);
    this.getPrioritiesInventoryByWarehouse();
  }

  selectProduct(product: ProductResponse) {
    clearTimeout(this.timeout);
    this.product.value = "";
    this.alreadyPriorities[product.id] = true;
    console.log(this.alreadyPriorities);

    var clone = Object.assign({}, product);
    var newPriority = new PrioritiesInventoryResponse();
    newPriority.id = null;
    newPriority.product = clone;
    newPriority.warehouse = this.warehouse.data.id;
    this.priorities.unshift(newPriority);
    this.updateProducts();
  }

  updateProducts() {
    if (!this.warehouse.data) {
      this.product.filterElements = [];
      return;
    }

    this.product.filterElements = this.products.filter(
      (p: ProductResponse) => {
        return !this.alreadyPriorities[p.id];
      }
    );
  }

  showDeleteQuestion(priority: PrioritiesInventoryResponse, index: number) {
    if (!priority.showDelete && !priority.id) {
      priority.deleting = false;
      priority.showDelete = false;
      this.priorities.splice(index, 1);
      delete this.alreadyPriorities[priority.product.id];
      this.updateProducts();
      return;
    }
    priority.showDelete = !priority.showDelete;
  }

  getPrioritiesInventoryByWarehouse() {
    if (!this.warehouse.data) {
      return;
    }

    this.inventoryService
      .getPrioritiesInventoryByWarehouse(this.warehouse.data.id)
      .subscribe({
        next: (response: ResponseObject) => {

          this.priorities = response.data || [];

          this.alreadyPriorities = {};

          this.priorities.forEach((p) => {
            if (p.product?.id) {
              this.alreadyPriorities[p.product.id] = true;
            }
          });

          this.original = this.priorities.length;
          this.updateProducts();
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
          this.priorities = [];
          this.alreadyPriorities = {};
          this.original = 0;

          this.toastService.error(
            "Error al obtener las prioridades de inventario"
          );
        }
      });
  }

  deletePriority(priority: PrioritiesInventoryResponse, index: number) {
    if (priority.deleting) {
      return;
    }
    priority.deleting = true;
    if (priority.id) {
      this.inventoryService.deletePriority(priority.id).subscribe({
        next: (response: ResponseObject) => {
          priority.deleting = false;
          this.toastService.success("Prioridad eliminada correctamente");
          delete this.alreadyPriorities[priority.product.id];
          this.updateProducts();
          this.getPrioritiesInventoryByWarehouse();
        },
        error: (error: HttpErrorResponse) => {
          priority.deleting = false;
          this.toastService.error("Error al eliminar la prioridad");
        }
      })
    } else {
      priority.deleting = false;
      priority.showDelete = false;
      delete this.alreadyPriorities[priority.product.id];
      this.updateProducts();
      this.priorities.splice(index, 1);
    }
  }
}
